import { Directive, inject } from '@angular/core';
import { Dialog } from 'primeng/dialog';

@Directive({
  selector: '[appPrimengDialog]',
  standalone: true,
})
export class PrimengDialogDirective {
  private readonly dialog = inject(Dialog);

  public constructor() {
    this.configureDefaultDialog();
  }

  private configureDefaultDialog(): void {
    this.dialog.draggable = false;
    this.dialog.maximizable = false;
    this.dialog.resizable = false;
    this.dialog.modal = true;
    this.dialog.closeOnEscape = false;
    this.dialog.style = { ...this.dialog.style, width: '40rem' };
    // this.dialog.appendTo = 'body';
  }
}
